const plMessages = {
  /* 01.General */
  "main.name": "Nazwa",
  "main.sentiment": "Nastrój",
  "main.urgency": "Pilność",
  "main.language": "Język",
  "main.agent": "Agent",
  "main.property_name": "Nazwa obiektu",
  "main.booking_number": "Numer rezerwacji",
  "main.check_out": "Wymeldowanie",
  "main.check_in": "Zameldowanie",
  "main.adults": "Dorośli",
  "main.corporate_code": "Kod firmowy",
  "main.group_code": "Kod grupy",
  "main.promo_code": "Kod promocyjny",
  "main.ai_response": "Odpowiedź AI",
  "main.template_response": "Odpowiedź szablonu",
  "main.converttoticket": "Konwertuj na zgłoszenie",
  "main.switch_property": "Zmień obiekt",
  "main.Group_id": "ID grupy",
  "main.integration_id": "ID integracji",
  "main.submit": "Prześlij",
  "main.cancel": "Anuluj",
  "main.select_template": "Wybierz szablon",
  "main.rooms": "Pokoje",
  "main.rates": "Stawki",
  
  //footer
   "footer.knowledge": "Wiedza",
  "footer.home": "Strona główna",
  "footer.help": "Pomoc",

  //ticket
  "ticket.thank_you": "Dziękujemy za przesłanie formularza",
  "ticket.ticket": "Zgłoszenie",
  "ticket.details": "Proszę wypełnić formularz opisujący szczegóły zgłoszenia.",
  "ticket.select_category": "Wybierz kategorię",
  "ticket.category": "Kategoria",
  "ticket.title": "Tytuł",
  "ticket.notes": "Notatki",
  "ticket.status": "Status",
  "ticket.assigned_to": "Przypisane do",
  "ticket.submit_form": "Prześlij formularz",

  
  "main.total": "Razem",
  "main.pastetooutlook": "Wklej do Outlook",
  "main.children": "Dzieci",
  "main.promocode": "Kod promocyjny/firmowy/grupowy",
  "main.exact_match_only": "Tylko dokładne dopasowanie",
  "main.search": "Szukaj",
  "main.no_rate_match": "Brak stawek pasujących do wybranego kryterium. Zmień wyszukiwanie i spróbuj ponownie.",
  "main.translate_to": "Przetłumacz na",
  "main.regenerate": "Wygeneruj ponownie",
  "main.copy_text": "Kopiuj tekst",
  "main.additional_instructions": "Dodatkowe instrukcje",

  "faq.helpcenter": "Centrum pomocy",
  "faq.reply.email.sabre.question": "Jak odpowiedzieć na wiadomość e-mail za pomocą Aven Hospitality Concierge Email Automation?",
  "faq.reply.email.sabre.answer": "Otwórz wiadomość e-mail i uruchom dodatek Aven Hospitality. Możesz wybrać jedną z trzech opcji: użyć gotowego szablonu, wygenerować odpowiedź AI lub przekształcić wiadomość w zgłoszenie. Wybierz odpowiednią opcję, sprawdź odpowiedź, wprowadź zmiany w razie potrzeby i wyślij bezpośrednio z Outlook.",

  "faq.rates.availability.question": "Jak dodać ceny, dostępność i szczegóły pokoi do odpowiedzi?",
  "faq.rates.availability.answer": "Użyj funkcji + Rates, aby wprowadzić dane gościa, takie jak daty i liczba osób. Concierge doda dokładne ceny i dostępność do odpowiedzi. Możesz również użyć + Rooms, aby dodać opisy pokoi i zdjęcia.",

  "faq.different.language.question": "Co zrobić, jeśli wiadomość e-mail jest w innym języku?",
  "faq.different.language.answer": "Aven Hospitality Concierge umożliwia tłumaczenie przychodzących wiadomości e-mail na preferowany język.",

  "faq.pin.addin.question": "Jak upewnić się, że dodatek jest zawsze dostępny w Outlook?",
  "faq.pin.addin.answer": "Przypnij dodatek Aven Hospitality Concierge w Outlook, aby był zawsze widoczny.",

  "faq.knowledge.hub.question": "Czym jest opcja wyszukiwania Knowledge Hub?",
  "faq.knowledge.hub.answer": "Wyszukiwanie Knowledge Hub umożliwia szybkie znalezienie informacji dotyczących obiektu bezpośrednio w Outlook.",

  "faq.reply.email.myma.question": "Jak odpowiedzieć na wiadomość e-mail za pomocą Myma?",
  "faq.reply.email.myma.answer": "Otwórz wiadomość i uruchom dodatek Myma. Możesz użyć szablonu, wygenerować odpowiedź AI lub przekształcić wiadomość w zgłoszenie.",

  "faq.room.details.question": "Jak dodać szczegóły pokoju do odpowiedzi?",
  "faq.room.details.answer": "Użyj + Rooms, aby dodać opisy pokoi i zdjęcia.",

  "faq.myma.different.language.question": "Co zrobić, jeśli wiadomość jest w innym języku?",
  "faq.myma.different.language.answer": "Myma umożliwia tłumaczenie przychodzących wiadomości e-mail na preferowany język.",

  "faq.myma.pin.addin.question": "Jak upewnić się, że dodatek jest zawsze dostępny w Outlook?",
  "faq.myma.pin.addin.answer": "Przypnij dodatek Myma w Outlook, aby otwierał się automatycznie przy każdej wiadomości.",
};

export default plMessages;